function About(){
    return(
        <div className="about">
            <h1>About</h1>
            <h3>Profile</h3>
            <p>I am interested and like to learn new things, although it takes time to adapt. I can work in a team and individually, I want to always explore my potential until I see how far I can go.
            </p>
            <ul>
                <li> <strong>Name:</strong> <span>Choyrul Annam, S.Kom</span></li>
                <li> <strong>Birthday:</strong> <span>2 Desember 1993</span></li>
                <li> <strong>Education:</strong> <span>Information System</span></li>
                <li> <strong>Emial:</strong> <span>Choy.annam@gmail.com</span></li>
                <li> <strong>City:</strong> <span>Cileungsih, Jawa Barat</span></li>
            </ul>
            <h3>Skills</h3>
            <div className="skill-warp">
                <div className="skill">
                    <label>HTML:</label>
                    <progress value="90" max="100"></progress>
                    <label>CSS (Boostrap):</label>
                    <progress value="60" max="100"></progress>
                    <label>PHP (Codeigniter,Laravel):</label>
                    <progress value="80" max="100"></progress>
                    <label>Javascript (JQuery):</label>
                    <progress value="70" max="100"></progress>
                    <label>MySQL:</label>
                    <progress value="75" max="100"></progress>
                </div>
                <div className="skill">
                    <label>React.Js:</label>
                    <progress value="50" max="100"></progress>
                    <label>Node.Js (Express):</label>
                    <progress value="50" max="100"></progress>
                    <label>Photoshop:</label>
                    <progress value="60" max="100"></progress>
                    <label>Adobe Ilustrator:</label>
                    <progress value="60" max="100"></progress>
                    <label>SolidWorks:</label>
                    <progress value="70" max="100"></progress>
                </div>
            </div>
        </div>
    );
}

export default About;